document.addEventListener('DOMContentLoaded', function () {
    const containers = document.querySelectorAll('.chart-container[data-chart]');
    if (!containers.length) return;

    const SVG_NS = 'http://www.w3.org/2000/svg';
    const DURATION = 800;

    function easeInOut(t) {
        t = Math.max(0, Math.min(1, t));
        const eased = t * t;
        return eased * 0.7 + t * 0.3;
    }

    function buildChart(container) {
        const svg = container.querySelector('svg.pie-chart');
        if (!svg || svg.dataset.rendered === 'true') return;
        svg.dataset.rendered = 'true';

        let data;
        try {
            data = JSON.parse(container.getAttribute('data-chart')) || [];
        } catch (err) {
            return;
        }
        if (!data.length) return;

        const cx = 50, cy = 50, r = 25;
        const circumference = 2 * Math.PI * r;

        svg.setAttribute('viewBox', '0 0 100 100');
        svg.style.transform = 'rotate(-90deg)';
        svg.style.transformOrigin = 'center';

        // Build slice metadata and create circles up front
        const slices = [];
        let cumulativePct = 0;

        data.forEach(function (slice, index) {
            const pct = Math.max(0, Math.min(100, Number(slice.percentage) || 0));
            if (pct <= 0) return;

            const startPct = Math.min(cumulativePct, 100);
            const endPct   = Math.min(cumulativePct + pct, 100);

            let dashLength = (pct / 100) * circumference;
            if (index === data.length - 1) {
                dashLength = Math.min(dashLength, circumference - 0.5);
            }
            const startOffset = -((startPct / 100) * circumference);

            const circle = document.createElementNS(SVG_NS, 'circle');
            circle.setAttribute('cx', cx);
            circle.setAttribute('cy', cy);
            circle.setAttribute('r', r);
            circle.setAttribute('fill', 'transparent');
            circle.setAttribute('stroke', slice.color || '#000');
            circle.setAttribute('stroke-width', 50);
            circle.setAttribute('stroke-dasharray', `0 ${circumference}`);
            circle.setAttribute('stroke-dashoffset', startOffset);
            svg.appendChild(circle);

            slices.push({
                circle: circle,
                dashLength: dashLength,
                startPct: startPct,
                endPct: endPct
            });

            cumulativePct += pct;
        });

        // rAF-driven animation loop
        let startTimestamp = null;

        function tick(now) {
            if (startTimestamp === null) startTimestamp = now;
            const elapsed = now - startTimestamp;
            const rawProgress = Math.min(1, elapsed / DURATION);
            // Invert easing: we want easing on the *time* axis mapped to progress
            // Total progress across all slices from 0..1
            const easedProgress = easeInOut(rawProgress);
            // The eased curve tells us "what fraction of the total sweep is done"
            const totalPctDrawn = easedProgress * 100;

            slices.forEach(function (s) {
                let sliceProgress;
                if (totalPctDrawn <= s.startPct) {
                    sliceProgress = 0;
                } else if (totalPctDrawn >= s.endPct) {
                    sliceProgress = 1;
                } else {
                    sliceProgress = (totalPctDrawn - s.startPct) / (s.endPct - s.startPct);
                }
                const currentDash = s.dashLength * sliceProgress;
                s.circle.setAttribute('stroke-dasharray', `${currentDash} ${circumference}`);
            });

            if (rawProgress < 1) {
                requestAnimationFrame(tick);
            }
        }

        requestAnimationFrame(tick);

        // Center text fade in
        const centerText = container.querySelector('.pie-chart-center');
        if (centerText) {
            centerText.style.transition = 'opacity 400ms ease';
            setTimeout(function () {
                centerText.style.opacity = '1';
            }, DURATION + 50);
        }
    }

    // Optional: reset a chart so it can replay on next activation
    function resetChart(container) {
        const svg = container.querySelector('svg.pie-chart');
        if (!svg) return;
        svg.querySelectorAll('circle').forEach((c) => c.remove());
        delete svg.dataset.rendered;

        const centerText = container.querySelector('.pie-chart-center');
        if (centerText) {
            centerText.style.transition = '';
            centerText.style.opacity = '0';
        }
    }

    // Split containers: inside a scrollytelling frame vs. standalone
    const frameContainers = [];
    const standaloneContainers = [];

    containers.forEach((c) => {
        // Only the desktop scrollytelling frames are .js-image inside .js-image-panel.
        // Mobile chart markup in this block lives in .mobile-layout (no .js-image parent),
        // so it correctly falls into "standalone" and keeps IntersectionObserver behavior.
        const frame = c.closest('.js-image-panel .js-image');
        if (frame) {
            frameContainers.push({ container: c, frame });
        } else {
            standaloneContainers.push(c);
        }
    });

    // 1) Scrollytelling frames: build when the frame is BOTH activated AND visible in viewport
    const frameIO = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const frame = entry.target;
        const container = frame.querySelector('.chart-container');
        if (!container) return;
        frameIO.unobserve(frame);
        buildChart(container);
      });
    }, {
      rootMargin: '-30% 0px -30% 0px',
      threshold: 0
    });

    frameContainers.forEach(({ container, frame }) => {
      frameIO.observe(frame);
      // Optional: also rebuild on frame:activate for re-entry replays
      // frame.addEventListener('frame:activate', () => buildChart(container));
    });

    // 2) Standalone (mobile block charts, other blocks): keep the original behavior
    if (!standaloneContainers.length) return;

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    observer.unobserve(entry.target);
                    buildChart(entry.target);
                }
            });
        }, { threshold: 0.3 });

        standaloneContainers.forEach(function (c) { observer.observe(c); });
    } else {
        standaloneContainers.forEach(buildChart);
    }

    function isFrameActive(frame) {
        // GSAP autoAlpha sets both opacity and visibility. Inactive frames
        // have visibility:hidden and opacity:0 during the initial state.
        const cs = window.getComputedStyle(frame);
        return cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.5;
    }
});